import { combineReducers } from "redux";

import user from './user';
import status from './status';
import products from './products';
import substances from './substances';
import profiles from './profiles';
import local from './local';
import stats from './stats';
import experiences from './experiences';
import multiparametricAnalysis from './multiparametricAnalysis';


export default combineReducers({
    user,
    status,
    products,
    substances,
    profiles,
    local,
    stats,
    experiences,
    multiparametricAnalysis,
});
